import type { IconProps } from './typesIcons'

export default function IconHasNoClube({
  height = 24,
  width = 25,
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.729 2C18.252 2 22.729 6.477 22.729 12C22.729 17.523 18.252 22 12.729 22C7.206 22 2.729 17.523 2.729 12C2.729 6.477 7.206 2 12.729 2ZM12.729 4C8.31073 4 4.729 7.58172 4.729 12C4.729 16.4183 8.31073 20 12.729 20C17.1473 20 20.729 16.4183 20.729 12C20.729 7.58172 17.1473 4 12.729 4ZM16.9722 9.17188L14.1431 12L16.9722 14.8281L15.5571 16.2432L12.729 13.4141L9.90088 16.2432L8.48584 14.8281L11.3149 12L8.48584 9.17188L9.90088 7.75684L12.729 10.5859L15.5571 7.75684L16.9722 9.17188Z"
        fill="#C3C3C3"
      />
    </svg>
  )
}
